module.exports = __webpack_public_path__ + "img/abdera-helfen.25a5fd2f.jpg";